import React from 'react';
import './Heading.css';

function Heading() {
    return (
        <div className='header'>
            <h1>Alexa Whitney</h1>
            <h2>ACS 1320 Final Assessment</h2>
        </div>
    )
}

export default Heading;